module.exports = __webpack_public_path__ + "static/img/product4-3.c2269f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product4-3.jpg
// module id = aN2p
// module chunks = 0